module.exports = __webpack_public_path__ + "static/media/plusbubble.9b752adc.png";